import { DEVICE_ID_STORAGE_KEY } from '@connect-x-app/shared-utils';

export const storage = localStorage;

export const clearStorage = () => {
  const deviceId = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
  localStorage.clear();
  if (deviceId) {
    localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
  }
};

// Not needed for web so it is here for typing reasons. It is only needed for the mobile implementation
export const useCustomMMKVDevTools = () => {};
